<div #navbar class="navbar sticky-top doNotPrint">
  <div class="row" style="width: 100vw">
    <div
      class="col-2 col-md-1 d-flex justify-content-center align-items-center"
    >
      <button class="btn menuButton" type="button" (click)="toggleSidebar()">
        <i class="fa fa-bars rotate navBarIcon"></i>
      </button>
    </div>
    <div class="col d-flex align-items-center">
      @if (sharedService.isOperatingUser()) {
        <span class="badge text-bg-warning">
          {{ loggedInCompanyName }} | {{ loggedInCompanyUid }}</span
        >
      }
    </div>
    <div class="col d-flex justify-content-end">
      <div class="col d-flex justify-content-end">
        <button
          class="btn navBarButton"
          type="button"
          (click)="openAssetSheetLog()"
          placement="bottom"
        >
          <i class="fab fa-google navBarIcon"></i>
        </button>
        @if (
          sharedService.isExpenseAdmin() == false &&
          sharedService.isAdminHead() == false
        ) {
          @if (sharedService.isBossAccount() || sharedService.isAdmin()) {
            <button
              class="btn navBarButton"
              type="button"
              (click)="openEditCommissionModal()"
              ngbTooltip="Edit Commission"
            >
              <i class="fas fa-marker navBarIcon"></i>
            </button>
          }
          @if (sharedService.isBossAccount() || sharedService.isFinance()) {
            <button
              class="btn navBarButton"
              type="button"
              (click)="goToBookmarks()"
              ngbTooltip="Quick Access Ticket"
            >
              <i class="fas fa-bookmark navBarIcon"></i>
            </button>
          }
          @if (sharedService.isOperatingUser() == false) {
            <button
              class="btn navBarButton"
              type="button"
              (click)="openSearchTicketModal()"
              ngbTooltip="Search Ticket"
            >
              <i class="fas fa-ticket-alt navBarIcon"></i>
            </button>
          }
          <ng-template #tooltipValidate>
            <div><span>Check EPF STATEMENT</span></div>
          </ng-template>
          @if (!sharedService.isFinance()) {
            <button
              class="btn navBarButton"
              type="button"
              (click)="openValidateEPFStatement()"
              [ngbTooltip]="tooltipValidate"
              placement="bottom"
            >
              <i class="fas fa-clipboard-check navBarIcon"></i>
            </button>
          }
          <ng-template #tooltipCalculator>
            <div><span>Quick Calculate EPF</span></div>
          </ng-template>
          <button
            class="btn navBarButton"
            type="button"
            (click)="openEPFCalculatorModal()"
            [ngbTooltip]="tooltipCalculator"
            placement="bottom"
          >
            <i class="fas fa-calculator navBarIcon" style="color: #ffbd33"></i>
          </button>
          <ng-template #tooltipReallocate>
            <div><span>Reallocate Fund</span></div>
          </ng-template>
          @if (sharedService.isBranchAccountHandler()) {
            <button
              class="btn navBarButton"
              type="button"
              (click)="openFundAllocationModal()"
              [ngbTooltip]="tooltipReallocate"
              placement="bottom"
            >
              <i class="fas fa-search-dollar navBarIcon"></i>
            </button>
          }
          <div class="dropdown d-flex">
            <button
              class="btn dropdown-toggle navBarButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              type="button"
            >
              <i class="fa fa-search navBarIcon"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" role="menu">
              @if (
                sharedService.isAdmin() ||
                sharedService.isBossAccount() ||
                sharedService.isFinance()
              ) {
                <a
                  class="dropdown-item"
                  role="presentation"
                  (click)="openGlobalSearchModal(true)"
                  >Global Search Customer</a
                >
              } @else {
                <a
                  class="dropdown-item"
                  role="presentation"
                  (click)="openGlobalSearchModal(false)"
                  >Search Customer Profile</a
                >
              }
              <a
                class="dropdown-item"
                role="presentation"
                (click)="openSearchCustomerByReceiptModal()"
                [hidden]="
                  sharedService.isAdmin() == true ||
                  sharedService.isBossAccount() ||
                  sharedService.isFinance()
                "
                >Search Customer by Receipt</a
              >
              <a
                class="dropdown-item"
                role="presentation"
                (click)="openSearchTaskModal()"
                [hidden]="
                  sharedService.isAdmin() == true ||
                  sharedService.isBossAccount() ||
                  sharedService.isFinance()
                "
                >Search Task</a
              >
              <a
                class="dropdown-item"
                role="presentation"
                (click)="openGlobalSearchModal(true)"
                style="background-color: lightblue"
                [hidden]="
                  sharedService.isAdmin() == true ||
                  sharedService.isBossAccount() ||
                  sharedService.isFinance()
                "
                >Global Search Customer</a
              >
            </div>
          </div>
          @if (!sharedService.isFinance()) {
            <div class="dropdown d-flex">
              <button
                class="btn dropdown-toggle navBarButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fa fa-plus navBarIcon"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" role="menu">
                <a
                  class="dropdown-item"
                  role="presentation"
                  (click)="openAddCustomerModal()"
                  >Add Customer</a
                >
                @if (
                  sharedService.isStaff() == false &&
                  sharedService.isBookkeepingStaff() == false
                ) {
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddAccountModal()"
                    >Add Account</a
                  >
                  <div class="dropdown-divider"></div>
                  <h6 class="dropdown-header">Asset Request Messages</h6>
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddApplyExpensesModal()"
                    >Add Apply Cash Request</a
                  >
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddReturnCashRequestModal()"
                    >Add Return Cash Request</a
                  >
                }
                <!-- <a class="dropdown-item" role="presentation"  data-bs-toggle="modal" data-target="#addPlan">Add Plan</a> -->
                @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddPlanModal()"
                    >Add Plan</a
                  >
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddSubTypeModal()"
                    >Add SubType</a
                  >
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddBlacklistCustomer()"
                    >Add Blacklist Record</a
                  >
                }
                @if (sharedService.isBossAccount()) {
                  <a
                    class="dropdown-item"
                    role="presentation"
                    (click)="openAddTransactionRequestModal()"
                    >Add Transaction Request</a
                  >
                }
              </div>
            </div>
          }
        }
        <div class="dropdown d-none d-md-block">
          <button
            class="btn dropdown-toggle navBarButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            type="button"
          >
            <img
              class="avatar"
              src="../assets/image/man-avatar.png"
              style="width: 50px"
            />
          </button>
          <div class="dropdown-menu dropdown-menu-end" role="menu">
            <a class="dropdown-item" role="presentation"
              ><strong>{{ loggedInUser | uppercase }}</strong></a
            >
            <a
              class="dropdown-item"
              role="presentation"
              (click)="openEditProfileModal()"
              >Edit Profile</a
            >
            @if (sharedService.isBossAccount()) {
              <a
                class="dropdown-item"
                role="presentation"
                (click)="goToServerStatusPage()"
                >Server Status</a
              >
            }
            @if (sharedService.isBossAccount()) {
              <a
                class="dropdown-item"
                role="presentation"
                (click)="goToAuthLogPage()"
                >Auth Log</a
              >
            }
            <a
              class="dropdown-item"
              role="presentation"
              style="color: red"
              (click)="logout()"
            >
              <strong>LOGOUT</strong></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
